/**
 * @param {import('@resider/types').ExploreFilters} filters
 * @returns {URLSearchParams}
 */
export default function formatFiltersUrlSearchParams(filters) {
  const params = new URLSearchParams();

  for (const key of Object.keys(filters)) {
    // eslint-disable-next-line no-prototype-builtins
    if (filters.hasOwnProperty(key)) {
      const value = filters[key];
      if (typeof value === 'object') {
        if (value?.length || (value?.min && value?.max)) {
          params.set(key, JSON.stringify(value));
        } else if (value?.min && !value?.max) {
          params.set(key, JSON.stringify({ min: value?.min }));
        } else if (value?.max && !value?.min) {
          params.set(key, JSON.stringify({ max: value?.max }));
        }
      } else if (typeof value === 'string' && value?.length) {
        params.set(key, value);
      } else if (typeof value === 'number') {
        params.set(key, `${value}`);
      }
    }
  }

  params.delete('open_dialog');
  params.delete('location_type');

  return params;
}
